import {
  LOAD_MONITORS_REQUEST, LOAD_MONITORS_SUCCESS, LOAD_MONITORS_ERROR
} from 'redux/actions';


// default states
const monitorsState = {
  loadedMonitors: {},
  isFetching: false,
  error: false
};

// reducers
function monitors(state = monitorsState, action) {
  const { loadedMonitors, error } = action;
  switch (action.type) {
    case LOAD_MONITORS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case LOAD_MONITORS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        loadedMonitors
      };
    case LOAD_MONITORS_ERROR:
      return {
        ...state,
        isFetching: false,
        error
      };
    default:
      return state;
  }
}

export default monitors;
